import { render, staticRenderFns } from "./importantHint.vue?vue&type=template&id=0904cead&scoped=true&"
import script from "./importantHint.vue?vue&type=script&lang=js&"
export * from "./importantHint.vue?vue&type=script&lang=js&"
import style0 from "./importantHint.vue?vue&type=style&index=0&id=0904cead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904cead",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0904cead')) {
      api.createRecord('0904cead', component.options)
    } else {
      api.reload('0904cead', component.options)
    }
    module.hot.accept("./importantHint.vue?vue&type=template&id=0904cead&scoped=true&", function () {
      api.rerender('0904cead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/dialog/importantHint.vue"
export default component.exports